import { SideBarDef } from "ag-grid-community";
import { useMemo } from "react";
import IssueTableInfoPanel from "./IssueTableInfoPanel";

const COLUMN_PANEL_SEEN_STORAGE_KEY = "columnPanelSeen";

export const useIssueTableSidebar = () => {
  const icons = useMemo<{
    [key: string]: ((...args: any[]) => any) | string;
  }>(
    () => ({
      "export-panel": '<span class="fa fa-file-excel-o fa-fw"></span>',
      info: '<span class="fa fa-question-circle"></span>',
    }),
    [],
  );

  const sideBar = useMemo<SideBarDef>(
    () => ({
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivotMode: true,
          },
        },
        {
          id: "info",
          labelDefault: "Info",
          labelKey: "info",
          iconKey: "info",
          toolPanel: IssueTableInfoPanel,
        },
      ],
      position: "left",
      defaultToolPanel: localStorage.getItem(COLUMN_PANEL_SEEN_STORAGE_KEY) === "true" ? "" : "columns",
    }),
    [],
  );

  const handleToolPanelVisibleChanged = (params) => {
    if (params.key === "columns" && params.visible === false) {
      localStorage.setItem(COLUMN_PANEL_SEEN_STORAGE_KEY, "true");
    }
  };

  return {
    handleToolPanelVisibleChanged,
    icons,
    sideBar,
  };
};
